import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { StarGlyph } from "./Ornaments";

const links = [
  { label: "The Story", href: "#story" },
  { label: "The Method", href: "#method" },
  { label: "The Alliance", href: "#alliance" },
  { label: "The Workbook", href: "#workbook" },
  { label: "MOVE THRUS™", href: "https://movethrus.com/", external: true },
  { label: "Connect", href: "#connect" },
];

const slugify = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const NavLink = ({ link, prefix, onClick }) => (
  <a
    href={link.href}
    className="nav-link"
    onClick={onClick}
    data-testid={`${prefix}-${slugify(link.label)}`}
    {...(link.external ? { target: "_blank", rel: "noopener noreferrer", style: { color: "var(--gold-bright)" } } : {})}
  >
    {link.label}
  </a>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <>
      <nav className={`nav-bar ${scrolled ? "scrolled" : ""}`} data-testid="primary-nav">
        <div
          style={{
            maxWidth: 1240,
            margin: "0 auto",
            padding: "1.1rem 1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <a
            href="#top"
            className="brand-name"
            data-testid="nav-brand"
            style={{ display: "inline-flex", alignItems: "center", gap: "0.6rem" }}
          >
            <StarGlyph size={14} />
            Somatic Equilibrium
          </a>

          <ul
            style={{
              listStyle: "none",
              margin: 0,
              padding: 0,
              display: "flex",
              gap: "2.5rem",
            }}
            className="hidden md:flex"
          >
            {links.map((l) => (
              <li key={l.href}>
                <NavLink link={l} prefix="nav-link" />
              </li>
            ))}
          </ul>

          <button
            type="button"
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="md:hidden"
            style={{
              background: "transparent",
              border: "1px solid rgba(201,168,76,0.4)",
              color: "var(--gold)",
              padding: "0.5rem",
              cursor: "pointer",
              display: "inline-flex",
            }}
            data-testid="nav-menu-open"
          >
            <Menu size={18} />
          </button>
        </div>
      </nav>

      <div className={`mobile-nav ${open ? "open" : ""}`} data-testid="mobile-nav">
        <button
          type="button"
          aria-label="Close menu"
          onClick={close}
          style={{
            position: "absolute",
            top: "1.25rem",
            right: "1.25rem",
            background: "transparent",
            border: "1px solid rgba(201,168,76,0.4)",
            color: "var(--gold)",
            padding: "0.5rem",
            cursor: "pointer",
          }}
          data-testid="nav-menu-close"
        >
          <X size={18} />
        </button>
        {links.map((l) => (
          <NavLink key={l.href} link={l} prefix="mobile-nav-link" onClick={close} />
        ))}
      </div>
    </>
  );
};
